/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".faq-page-container[_ngcontent-%COMP%]{margin-bottom:10rem}.contact-us-btn-container[_ngcontent-%COMP%]{margin:2rem;text-align:right}.contact-us-btn[_ngcontent-%COMP%]{color:#efbd08;font:11px PoppinsSemiBold;letter-spacing:1px;text-transform:uppercase}"];
export { styles as styles };
//# sourceMappingURL=faq-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/faq/faq-page/faq-page.component.scss.shim.ngstyle.js
// module id = 1634
// module chunks = 26 27 28